
const FirstStepWizardTextFieldLabel = ({label, isOptional, isEmpty}) => {
  
  const textColor = !isEmpty ? "text-green-600" : 
    isOptional ? "text-gray-600" :
      "text-red-600";

  return (
  <p className={`font-semibold ${textColor}`}>
      {label}
  </p>
  )
}

export default FirstStepWizardTextFieldLabel;
